const data = [
  {
    id: "DEV716627",
    title: "New Assignment added",
    when: "2 hours ago",
    type: "order",
    to: "/orders/DEV730658",
  },
  {
    id: "DEV853890",
    title: "Notice regarding exam",
    when: "3 hours ago",
    type: "user",
    to: "/users/DEV696649",
  },
  {
    id: "DEV897704",
    title: "Upcomming events",
    when: "1 day ago",
    type: "product",
    to: "/products/DEV654476",
  },
  {
    id: "DEV604714",
    title: "Exam fee sumbission",
    when: "2 day ago",
    type: "feature",
    to: "/features",
  },
];

export default data;
